import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/use-current-user';
import { FullPageLoader } from 'prosci-ui';
import { canAccessKaiyaSection } from '@/lib/kaiya-access';

export function KaiyaAdminRoute() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  // Kaiya section is limited to super, admin, and affiliate_admin.
  if (!canAccessKaiyaSection(currentUser)) {
    return <Navigate to="/users" replace />;
  }

  return <Outlet />;
}
